import { boot } from 'quasar/wrappers';
import {
  isToken,
  getToken,
  authByToken,
  getCredentials,
  getPharmacyOwner,
  readCrmPharmacyUser,
  updateCrmPharmacyUser,
  addPackagingTypeCrmPharmacy,
  updateManufacturingInstrCrmPharmacyUser,
  updatePackagingTypeCrmPharmacy, updatePharmacyScalesCrmPharmacy
} from 'src/js/auth.js';

export default boot(({ app }) => {
  app.config.globalProperties.$auth = {
    isToken,
    getToken,
    authByToken,
    readCrmPharmacyUser,
    updateManufacturingInstrCrmPharmacyUser,
    updatePackagingTypeCrmPharmacy,
    updatePharmacyScalesCrmPharmacy,
    getCredentials,
    getPharmacyOwner
  };
});
